import React, { useContext } from 'react';
import localization from '../../../constants/localization';

const EditGroupFolderRights = ({ groupRightsToFolders }) => {
  const LS = useContext(localization);

  const hasRight = {
    padding: '0 15px',
    textAlign: 'center',
  };

  const handleValue = (value) => {
    let read, write;
    switch (value) {
      case 'read/write':
        read = 'fa fa-check';
        write = 'fa fa-check';
        break;
      case 'read':
        read = 'fa fa-check';
        write = 'fa fa-times';
        break;
      default:
        read = 'fa fa-times';
        write = 'fa fa-check';
    }
    return (
      <>
        <td style={hasRight}>
          <i
            className={read}
            style={
              read === 'fa fa-check' ? { color: 'green' } : { color: 'red' }
            }
            aria-hidden="true"
          ></i>
        </td>
        <td style={hasRight}>
          <i
            className={write}
            style={
              write === 'fa fa-check' ? { color: 'green' } : { color: 'red' }
            }
            aria-hidden="true"
          ></i>
        </td>
      </>
    );
  };

  const handleFolders = (folderObject) => [
    <tr key="header">
      <th>{LS.manageGroups.folderName}</th>
      <th>{LS.manageGroups.read}</th>
      <th>{LS.manageGroups.write}</th>
    </tr>,
    Object.entries(folderObject).map(([key, value]) => (
      <tr key="key">
        <td>{key}</td>
        {handleValue(value)}
      </tr>
    )),
  ];

  return (
    <table>
      {Object.keys(groupRightsToFolders)?.length !== 0 ? (
        handleFolders(groupRightsToFolders)
      ) : (
        <tr>{LS.manageGroups.noFolders}</tr>
      )}
    </table>
  );
};

export default EditGroupFolderRights;
